import {useCallback} from 'react';

import {FillPlateModalState} from './machine/FillPlateModalConstants';
import {PlateModalMachineEvents} from './machine/PlateModalMachine';
import {usePlateModalActorRef, usePlateModalSelector} from './PlateModalMachineProvider';

/**
 * Custom hook that provides the state and send function from PlateModalMachine context.
 * Returns the machine state and a send function for dispatching actions.
 */
export function usePlateModalMachine(): [FillPlateModalState, (action: PlateModalMachineEvents) => void] {
  const actorRef = usePlateModalActorRef();

  // Get the current state from the machine context
  const state = usePlateModalSelector((snapshot) => snapshot.context);

  // Create a send function that sends actions to the machine
  const send = useCallback(
    (action: PlateModalMachineEvents) => {
      actorRef.send(action);
    },
    [actorRef]
  );

  return [state, send];
}
